import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton } from '@material-ui/core';
import { colors } from '../../theme/color-palette';
import CloseIcon from '@material-ui/icons/Close';
import { useMediaQuery } from '@mui/material';
const { FONT_COLOR, ERROR_MIN, ERROR_MD, ERROR_HIGH, ERROR_LIGHT } = colors;

const useStyles = makeStyles(() => ({
	toastMessage: {
		position: 'absolute',
		right: '16px',
		color: FONT_COLOR,
	},
	box: {
		display: 'flex',
		alignItems: 'center',
		borderRadius: '5px',
		marginTop: (P) => P.marginTop,
		marginRight: (P) => P.marginRight,
		marginBottom: (P) => P.marginBottom,
		marginLeft: (P) => P.marginLeft,
		padding: '12px 22px 12px 10px',
		height: '16px',
		border: (P) => `1px solid ${P.borderColor}`,
		backgroundColor: (P) => P.backgroundColor,
		borderLeft: (P) => `6px solid ${P.boderLeftColor}`,
		color: (P) => P.color,
		fontSize: (P) => (P.isSmallScreen ? '16px' : '12px'),
	},
	text: {
		width: '90%',
		color: (P) => P.textColor,
	},
	righttext: {
		color: (P) => P.textColor,
		textDecoration: 'underline',
		cursor: 'pointer',
		borderStyle: 'none',
		backgroundColor: (P) => P.backgroundColor,
	},
}));

const Alert = (props) => {
	const {
		handleClose,
		errorMsg,
		alertbutton,
		handlebuttonClick,
		icon,
		borderColor,
		backgroundColor,
		boderLeftColor,
		color,
		textColor,
		marginTop,
		marginLeft,
		marginRight,
		marginBottom,
	} = props;
	const isSmallScreen = useMediaQuery('(min-width:540px)');
	const classes = useStyles({
		isSmallScreen,
		borderColor,
		backgroundColor,
		boderLeftColor,
		color,
		textColor,
		marginTop,
		marginLeft,
		marginRight,
		marginBottom,
	});

	return (
		<Box className={classes.box} data-test-id="duplicate-hierarchy">
			<img
				src={icon}
				alt="alert"
				style={{ marginTop: '1px', marginRight: '5px' }}
			/>
			<span className={classes.text}>{errorMsg}</span>
			<button className={classes.righttext} onClick={handlebuttonClick}>
				{alertbutton}
			</button>
			<IconButton
				id="close-drawer"
				aria-label="close-button"
				size="medium"
				onClick={handleClose}
				className={classes.toastMessage}>
				<CloseIcon style={{ color: '#590B0E' }} fontSize="inherit" />
			</IconButton>
		</Box>
	);
};

Alert.defaultProps = {
	handleClose: null,
	errorMsg: '',
	icon: null,
	warning: false,
	borderColor: ERROR_LIGHT,
	backgroundColor: ERROR_MIN,
	boderLeftColor: ERROR_MD,
	color: ERROR_HIGH,
	alertbutton: null,
	marginTop: '24px',
	marginLeft: 0,
	marginRight: 0,
	marginBottom: 0,
};

Alert.propTypes = {
	handleClose: PropTypes.func,
	errorMsg: PropTypes.string,
	icon: PropTypes.oneOf(['img', 'svg']),
	warning: PropTypes.bool,
	borderColor: PropTypes.string,
	backgroundColor: PropTypes.string,
	boderLeftColor: PropTypes.string,
	color: PropTypes.string,
	textColor: PropTypes.string,
	alertbutton: PropTypes.string,
	marginTop: PropTypes.string,
	marginLeft: PropTypes.string,
	marginRight: PropTypes.string,
	marginBottom: PropTypes.string,
	handlebuttonClick: PropTypes.string,
};

export default Alert;
